import { DMSIDS } from "models";
import {
  AutolineConfigSection,
  CarITConfigSection,
  EvaConfigSection,
  ICarConfigSection,
  IncadeaConfigSection,
  KeyloopConfigSection,
  NextlaneConfigSection,
  VinaclesConfigSection,
  WincarConfigSection
} from "modules/DMSv3/Settings/components/AddEditDealerModal/components";

const dmsDealerConfigurable = [
  DMSIDS.INCADEA,
  DMSIDS.INCADEA_API,
  DMSIDS.INCADEA_HYBRID,
  DMSIDS.ICAR_PLANNING,
  DMSIDS.ICAR_WO,
  DMSIDS.CARIT,
  DMSIDS.CARIT_HYBRID,
  DMSIDS.EVA,
  DMSIDS.ANON_EVA,
  DMSIDS.EVA_BE,
  DMSIDS.EVA_FR,
  DMSIDS.AUTOLINE,
  DMSIDS.AUTOLINE_EF_NEFKENS,
  DMSIDS.AUTOLINE_OPEL_MENU,
  DMSIDS.WINCAR,
  DMSIDS.WINCAR_API_EVENTS,
  DMSIDS.WINCAR_API_V2_EVENTS,
  DMSIDS.WINCAR_V1_WB,
  DMSIDS.WINCAR_V2_WB,
  DMSIDS.NEXTLANE,
  DMSIDS.KEYLOOP_MENUS,
  DMSIDS.KEYLOOP_MENUS_STAGING,
  DMSIDS.KEYLOOP_JOBS,
  DMSIDS.KEYLOOP_JOBS_STAGING,
  DMSIDS.VINACLES
];

export const doesDealerDmsConfigExists = (dmsId?: DMSIDS) => (dmsId ? dmsDealerConfigurable.includes(dmsId) : false);

type DmsConfigSectionProps = {
  dmsId?: DMSIDS;
};

export const DmsConfigSection = ({ dmsId }: DmsConfigSectionProps) => {
  switch (dmsId) {
    case DMSIDS.INCADEA:
    case DMSIDS.INCADEA_API:
    case DMSIDS.INCADEA_HYBRID:
      return <IncadeaConfigSection dmsId={dmsId} />;

    case DMSIDS.ICAR_PLANNING:
    case DMSIDS.ICAR_WO:
      return <ICarConfigSection />;

    case DMSIDS.CARIT:
    case DMSIDS.CARIT_HYBRID:
      return <CarITConfigSection dmsId={dmsId} />;

    case DMSIDS.EVA:
    case DMSIDS.ANON_EVA:
    case DMSIDS.EVA_BE:
    case DMSIDS.EVA_FR:
      return <EvaConfigSection />;

    case DMSIDS.AUTOLINE:
    case DMSIDS.AUTOLINE_EF_NEFKENS:
    case DMSIDS.AUTOLINE_OPEL_MENU:
      return <AutolineConfigSection />;

    case DMSIDS.WINCAR:
    case DMSIDS.WINCAR_API_EVENTS:
    case DMSIDS.WINCAR_API_V2_EVENTS:
    case DMSIDS.WINCAR_V1_WB:
    case DMSIDS.WINCAR_V2_WB:
      return <WincarConfigSection dmsId={dmsId} />;

    case DMSIDS.NEXTLANE:
      return <NextlaneConfigSection />;

    case DMSIDS.KEYLOOP_MENUS:
    case DMSIDS.KEYLOOP_MENUS_STAGING:
    case DMSIDS.KEYLOOP_JOBS:
    case DMSIDS.KEYLOOP_JOBS_STAGING:
      return <KeyloopConfigSection />;

    case DMSIDS.VINACLES:
      return <VinaclesConfigSection />;

    default:
      return null;
  }
};
